export default __webpack_public_path__ + "static/media/CQscreenshot.68f15916.PNG";